/* eslint-disable sonarjs/no-duplicate-string */
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  link: {
    borderRadius: 15,
    padding: "15px 0",
    color: theme.palette.secondary.main,
    fontSize: 17,
    lineHeight: "17px",
    transition: "background-color linear 50ms, padding-left linear 50ms, font-size linear 50ms",
    "&:hover": {
      color: "black",
      fontSize: 19,
      lineHeight: "19px",
      padding: 14,
      backgroundColor: theme.palette.primary.dark,
    },
  },
  itemsLink: {
    fontSize: "1rem",
    marginTop: 15,
    display: "block",
    width: "fit-content",
    color: theme.palette.secondary.main,
  },
  interactiveTitle: {
    marginBottom: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  wsDetailFieldsActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  cardPadding: {
    padding: theme.spacing(3),
  },
  statisticRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  basicInfoRow: {
    display: "grid",
    alignItems: "center",
    grid: "auto-flow / 1fr 2fr",
  },
  basicInfoLabel: {
    margin: 0,
    marginRight: 5,
    color: theme.palette.text.secondary,
  },
  basicInfoValue: {
    color: theme.palette.text.primary,
  },
  gridCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardTitle: {
    marginBottom: theme.spacing(2),
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    minHeight: 120,
  },
  emptyStateIcon: {
    fontSize: 48,
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  enhancedInfoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  infoIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.secondary.main,
    fontSize: 20,
  },
  infoContent: {
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  infoLabel: {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    minWidth: 80,
  },
  infoValue: {
    color: theme.palette.text.primary,
    fontWeight: 400,
  },
  tierChip: {
    textTransform: "capitalize",
    fontWeight: 600,
  },
  editableInfoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: 0,
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#ffffff",
    border: `1px solid ${theme.palette.grey[300]}`,
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
}));

export default useStyles;
